import { PIP_CALCULATOR } from '../constants';

const toggles = {
  TWO_POINT: '2_Point',
  THREE_POINT: '3_Point'
};

const lineItemNames = {
  PANEL: 'panel',
  BLOCK: 'block',
  SHEET: 'sheet',
  BAG: 'bag'
};

export const shouldDisplayPipCalculator = ({ info = {} }) => {
  return !!info?.pipCalculator?.display
    && !!info?.pipCalculator?.toggle
    && !!info?.pipCalculator?.coverageUnits
    && !!info?.pipCalculator?.publisher;
};

export const shouldDisplayQuantityCalculator = ({ fulfillment, installServices }) => {
  return !!(fulfillment?.fulfillmentOptions
    && !installServices?.scheduleAMeasure);
};

export const getCalculatorType = ({ fulfillment, installServices, info }) => {
  if (shouldDisplayQuantityCalculator({ fulfillment, installServices })) {
    if (shouldDisplayPipCalculator({ info })) {
      return PIP_CALCULATOR;
    }
  }

  return 'unknownCalculatorType';
};

export const shouldDisplayCalculator = ({ fulfillment, installServices, info, type }) => {
  return (getCalculatorType({ fulfillment, installServices, info }) === type);
};

export const returnCalculatorType = (toggle) => {
  if (toggle === toggles.TWO_POINT) return 'Area';
  if (toggle === toggles.THREE_POINT) return 'Volume';
  return '';
};

export const getLineItemName = (coverageUnits) => {
  const { PANEL, BLOCK, SHEET, BAG } = lineItemNames;
  if (coverageUnits === PANEL || coverageUnits === BLOCK || coverageUnits === SHEET) {
    return 'Wall';
  }
  if (coverageUnits === BAG) {
    return 'Space';
  }
  return 'Area';
};

export const getCaseUnitOfMeasure = (toggle) => {
  if (toggle === toggles.TWO_POINT) return 'sq. ft.';
  if (toggle === toggles.THREE_POINT) return 'cu. ft.';
  return '';
};

export const getDimensionNames = (coverageUnits) => {
  const { BLOCK, SHEET } = lineItemNames;
  if (coverageUnits === BLOCK) {
    return ['Width', 'Height'];
  }
  if (coverageUnits === SHEET) {
    return ['Width', 'Length'];
  }
  return ['Length', 'Width'];
};

export const getCalculatorProps = ({
  fulfillment,
  installServices,
  info,
}) => {
  const calculatorType = getCalculatorType({ fulfillment, installServices, info });
  if (calculatorType === PIP_CALCULATOR) {
    const toggle = info?.pipCalculator?.toggle;
    const coverageUnits = info?.pipCalculator?.coverageUnits;
    const publisher = info?.pipCalculator?.publisher;
    return {
      calculatorType: returnCalculatorType(toggle),
      lineItemName: getLineItemName(coverageUnits),
      uom: coverageUnits,
      uomPlural: coverageUnits + 's',
      dimensionName: getDimensionNames(coverageUnits),
      caseUnitOfMeasure: getCaseUnitOfMeasure(toggle),
      productCategory: 'products',
      unitsPerCase: publisher
    };
  }

  return null;
};